module.exports = __webpack_public_path__ + "static/media/sound_DB_icon.1e13aa91.svg";